<template>
  <ValidationObserver ref="observer" v-slot="{ invalid }">
    <tsny-modal
      :modal-id="modalId"
      :modal-title="'Create Course Relationship'"
      :submit-button-text="'CREATE'"
      :submit-disabled="invalid"
      :reset-modal="resetModal"
      :submit-modal="createCourseRelationship"
    >
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="Course Name">
              <b-select
                v-model="courseId"
                :options="courseOptions"
                class="tsny_dropdown"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-row>
              <b-col>
                <label class="tsny_field_header-text">Start Date</label
                ><i
                  class="ml-1 text-dark fas fa-info-circle"
                  v-b-tooltip.hover
                  title="Field optional, can be set later"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-input
                  type="date"
                  class="tsny_input"
                  v-model="startDate"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            ><label class="tsny_field_header-text">Session Start</label
            ><i
              class="ml-1 text-dark fas fa-info-circle"
              v-b-tooltip.hover
              title="Field optional, can be set later. Disabled without start date"
          /></b-col>
          <b-col
            ><label class="tsny_field_header-text">Session End</label
            ><i
              class="ml-1 text-dark fas fa-info-circle"
              v-b-tooltip.hover
              title="Field optional, can be set later. Disabled without start date"
          /></b-col>
        </b-row>
        <b-row class="mb-4">
          <b-col
            ><b-form-input
              type="time"
              class="tsny_input"
              v-model="sessionStartTime"
              :disabled="!startDate"
          /></b-col>
          <b-col
            ><b-form-input
              type="time"
              class="tsny_input"
              v-model="sessionEndTime"
              :disabled="!startDate"
          /></b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-text-input-validated
              :data-list="tutors"
              v-model="tutorEmail"
              rules="required|email"
              type="email"
              name="tutor email"
              label="Tutor Email"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-text-input-validated
              :data-list="students"
              v-model="studentEmail"
              rules="required|email"
              type="email"
              name="student email"
              label="Student Email"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <p v-if="createCourseRelationshipError" class="tsny_status-text">
              An error occurred creating the new course relationship
            </p>
          </b-col>
        </b-row>
      </b-form>
    </tsny-modal>
  </ValidationObserver>
</template>

<script>
import TsnyModal from "../TsnyModal";
import CourseRelationshipRestService from "../../services/rest/services/CourseRelationshipRestService";
import BTextInputValidated from "../FormInputs/BTextInputValidated";
import { ValidationObserver } from "vee-validate";
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";

export default {
  name: "CreateCourseRelationship",
  components: { tsnyModal: TsnyModal, ValidationObserver, BTextInputValidated },
  props: {
    students: {
      type: Array,
      default: null
    },
    tutors: {
      type: Array,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      courseNames: StoreConstants.GETTERS.COURSE_NAMES
    }),
    courseOptions() {
      return this.courseNames.map(course => course._id);
    }
  },
  data: function() {
    return {
      modalId: "createCourseRelationshipModal",
      courseId: null,
      studentEmail: null,
      tutorEmail: null,
      duration: null,
      startDate: null,
      sessionStartTime: null,
      sessionEndTime: null,
      createCourseRelationshipError: null
    };
  },
  methods: {
    resetModal: function() {
      this.courseId = null;
      this.studentEmail = null;
      this.tutorEmail = null;
      this.duration = null;
      this.startDate = null;
      this.sessionStartTime = null;
      this.sessionEndTime = null;
      this.createCourseRelationshipError = null;
    },
    createCourseRelationship: async function(bvModalEvent) {
      bvModalEvent.preventDefault();

      let $comp = this,
        isValid = await this.$refs.observer.validate();

      if (!isValid) return;

      $comp.createCourseRelationshipError = false;

      if (!$comp.startDate) {
        $comp.sessionStartTime = null;
        $comp.sessionEndTime = null;
      }

      return CourseRelationshipRestService.createCourseRelationship(
        $comp.courseId,
        $comp.studentEmail,
        $comp.tutorEmail,
        $comp.duration,
        $comp.startDate,
        $comp.sessionStartTime,
        $comp.sessionEndTime
      )
        .then(() => {
          $comp.$bvModal.hide($comp.modalId);
        })
        .catch(err => {
          console.log(err);
          $comp.createCourseRelationshipError = true;
        });
    }
  }
};
</script>

<style scoped></style>
